import apiClient from "./client";

export async function fetchSessionLockConfig() {
  const { data } = await apiClient.get("/security/session-lock");
  return data;
}

export async function fetchSecuritySettings() {
  const { data } = await apiClient.get("/security/settings");
  return data;
}

export async function updateSecuritySettings(payload) {
  const { data } = await apiClient.patch("/security/settings", payload);
  return data;
}

export const SECURITY_SETTINGS_CHANGED_EVENT = "credora-security-settings-changed";

export function notifySecuritySettingsChanged() {
  window.dispatchEvent(new Event(SECURITY_SETTINGS_CHANGED_EVENT));
}
